import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["newTab", "to", "onClick"];
import { Link as NextUILink } from "@nextui-org/react";
import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";
export var Link = function Link(_ref) {
  var _ref$newTab = _ref.newTab,
      newTab = _ref$newTab === void 0 ? false : _ref$newTab,
      to = _ref.to,
      onClickProp = _ref.onClick,
      props = _objectWithoutProperties(_ref, _excluded);

  var navigate = useNavigate();
  var onClick = useCallback(function (e) {
    onClickProp === null || onClickProp === void 0 ? void 0 : onClickProp(e);
    if (newTab) return;
    e.preventDefault();
    navigate(to);
  }, [navigate, newTab, onClickProp, to]);
  var href = to instanceof URL ? to.href : to;
  return /*#__PURE__*/React.createElement(NextUILink, _extends({}, props, {
    onClick: onClick,
    href: href
  }, newTab && {
    target: "_blank",
    rel: "noopener noreferrer"
  }));
};